import React, { useEffect, useState } from 'react'
import CategoriesApp, { ICategoryModel } from './CategoriesApp'
import GenerateIcon from '../../components/GenerateIcon'
import { Button, IconButton, Tooltip } from '@mui/material'
import { useDispatch } from 'react-redux'
import { deleteCategory } from './categoriesSlice'
import { handleRequestError } from '../../services/api'
import BasicModalWindow from '../../components/BasicModalWIndow'
import { Checkbox } from '@mui/material'

interface ISingleCategoryProps extends ICategoryModel {
    handleShowModal: () => void,
    handleHideModal: () => void,
    updateModalCategory: (category: ICategoryModel) => void,
    updateParentCategoryId: (id: number | null) => void,
    handleCategorySelect?: (category: ICategoryModel) => void,
    enableSelect?: boolean,
    disableAddNew?: boolean,
    checkedCategories?: number[],
    updateCheckedCategories?: (categories: number[]) => void
}

export default function SingleCategory(props: ISingleCategoryProps) {

    const dispatch = useDispatch()

    const {
        id,
        title,
        sub_categories,
        handleShowModal,
        handleHideModal,
        updateModalCategory,
        updateParentCategoryId,
        handleCategorySelect,
        category_id,
        enableSelect,
        disableAddNew,
        checkedCategories,
        updateCheckedCategories,
    } = props

    const categoriesApp = new CategoriesApp()

    const containerBaseClassName: string = "single-category-box"

    const [sureToDeleteModal, setSureToDeleteModal] = useState<boolean>(false)

    const [containerClassName, setContainerClassName] = useState<string>(containerBaseClassName)
    const [showSubCategories, setShowSubCategories] = useState<boolean>(false)

    useEffect(() => {
        setContainerClassName(showSubCategories ? containerBaseClassName + " show-sub-categroies" : containerBaseClassName)
    }, [showSubCategories])

    /**
     * New sub category
     */
    const newSubCategory = () => {
        updateParentCategoryId(id)
        handleShowModal()
    }

    /**
     * Update category
     */
    const updateCategory = () => {
        updateModalCategory(props)
        handleShowModal()
    }

    /**
     * Handle delete category
     */
    const handleDeleteCategory = () => {

        categoriesApp.deleteInstance(id)
            .then(response => {
                dispatch(deleteCategory({ id: id }))
            })
            .catch(error => {
                handleRequestError(error, dispatch)
            })

    }

    const showNewSubCategory = () => {

        if (disableAddNew){
            return false
        }

        if (sub_categories.length === 0){
            return true
        }

        return false
    }

    /**
     * Is category checked
     */
    const isCategoryChecked = (id: number) => {
        if (checkedCategories){
            return checkedCategories.includes(id)
        }

        return false
    }

    return(
        <div className={containerClassName}>
            <div className="content-of-single-category-box">

                <BasicModalWindow
                    shown={sureToDeleteModal}
                    handleClose={() => setSureToDeleteModal(false)}
                    title="Delete category"
                    actionButtons={[
                        {
                            label: "Cancel",
                            color: "success",
                            onClick: () => setSureToDeleteModal(false)
                        },
                        {
                            label: "Delete",
                            color: "error",
                            onClick: handleDeleteCategory
                        }
                    ]}
                    actionButtonsBottom
                    showHeader
                    size="sm"
                >
                    Are you sure that you want to delete "{title}" category?
                </BasicModalWindow>

                <div className="head-box-of-single-category-box">
                    <div className="content-of-head-box-of-single-category-box">

                        {/* {sub_categories.length > 0 && (
                            <div className={showSubCategories ? "show-more-box-of-head-box-of-single-category-box flip" : "show-more-box-of-head-box-of-single-category-box"}>
                                <div className="content-of-show-more-box-of-head-box-of-single-category-box">
                                    <IconButton onClick={() => setShowSubCategories(showSubCategories ? false : true)}>
                                        <GenerateIcon icon="arrow-down" />
                                    </IconButton>
                                </div>
                            </div>
                        )} */}

                        {enableSelect ? (
                            <Checkbox 
                                checked={isCategoryChecked(id)} 
                                inputProps={{ 'aria-label': 'controlled' }} 
                                onChange={(e) => {
                                    let checked = isCategoryChecked(id)



                                    if (updateCheckedCategories && checkedCategories){

                                        let selectedCategories: number[] = [
                                            ...checkedCategories,
                                            id,
                                        ]
                                        
                                        if (checked){
                                            selectedCategories = selectedCategories.filter(num => num !== id)

                                            if (sub_categories && sub_categories.length > 0){
                                                sub_categories.map((subCat) => {
                                                    selectedCategories = selectedCategories.filter(num => num !== subCat.id)
                                                })
                                            }

                                            setShowSubCategories(false)

                                        }else{

                                            if (sub_categories && sub_categories.length > 0){
                                                setShowSubCategories(true)

                                                sub_categories.map((subCat) => selectedCategories.push(subCat.id))
                                            }

                                        }

                                        updateCheckedCategories(selectedCategories)
                                    }

                                }}
                            />
                        ) : (
                            <IconButton disabled={sub_categories.length > 0 ? false : true} onClick={() => {
                                if (sub_categories.length > 0){
                                    setShowSubCategories(showSubCategories ? false : true)
                                }
                            }}>
                                <GenerateIcon 
                                    icon={showSubCategories ? "folder-open" : sub_categories.length > 0 ? "topic" : "folder"} 
                                />
                           </IconButton>
                        )}

                        <h3
                            onClick={() => {
                                if (handleCategorySelect){
                                    handleCategorySelect(props)
                                }

                                if (sub_categories.length > 0){
                                    setShowSubCategories(showSubCategories ? false : true)
                                }
                            }}

                            style={{
                                cursor: handleCategorySelect ? "pointer" : sub_categories.length > 0 ? "pointer" : "default"
                            }}
                        >
                            {title}
                        </h3>

                        {!disableAddNew && (
                            <div className="buttons-of-head-box-of-single-category-box">
                                    {showNewSubCategory() && (
                                    // {sub_categories.length === 0 && (

                                        <Tooltip title="Add new sub category" onClick={() => newSubCategory()}>
                                            <IconButton>
                                                <GenerateIcon icon="new" />
                                            </IconButton>
                                        </Tooltip>
                                    )}

                                    <Tooltip title="Edit category" onClick={() => updateCategory()}>
                                        <IconButton>
                                            <GenerateIcon icon="edit" />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Delete category" onClick={() => setSureToDeleteModal(true)}>
                                        <IconButton color="error">
                                            <GenerateIcon icon="delete" />
                                        </IconButton>
                                    </Tooltip>
                            </div>
                        )}

                    </div>
                    {/* {sub_categories.length === 0 && <Button className="general-button admin-style new-sub-category-button" startIcon={<GenerateIcon icon="new" />}>New sub category</Button>} */}
                </div>

                {sub_categories.length > 0 && (
                    <div className={showSubCategories ? "sub-categories-container-of-single-category-box show-sub-categroies" : "sub-categories-container-of-single-category-box"}>
                        <div className="content-of-sub-categories-container-of-single-category-box">
                            {sub_categories.map((category, index) => <SingleCategory {...category} key={index} disableAddNew={disableAddNew} enableSelect={enableSelect} updateCheckedCategories={updateCheckedCategories} checkedCategories={checkedCategories} handleHideModal={handleHideModal} handleShowModal={handleShowModal} updateModalCategory={updateModalCategory} updateParentCategoryId={updateParentCategoryId} handleCategorySelect={handleCategorySelect} />)}
                            <div className="sub-categories-vertical-line"></div>
                        </div>

                        {!disableAddNew && (
                            <div className="new-sub-category-button-box">
                                <div className="content-of-new-sub-category-button-box">
                                    <Button className="general-button admin-style" startIcon={<GenerateIcon icon="new" />} onClick={() => newSubCategory()}>
                                        New sub category
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                )}

            </div>
        </div>
    )
}